"use client";

import { defaultLocale, type Locale } from "@/lib/i18n";
import AgentUseCasePage from "./AgentUseCasePage";
import { bankReconciliation } from "@/content/agent-use-cases/bank-reconciliation";

export default function BankReconciliationUseCase({
  locale = defaultLocale,
}: {
  locale?: Locale;
}) {
  return <AgentUseCasePage useCase={bankReconciliation} locale={locale} />;
}
